import {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Select,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import qs from 'qs'
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Tuning2OutlineIcon } from '../../../components/AppIcon'
import EmptyContent from '../../../components/EmptyContent'
import { DATE_FORMAT_LIST, ISO_DATE_FORMAT } from '../../../constants'
import utils from '../../../utils'
import { checkValidFormFieldValue } from '../../../utils/helper'

const { RangePicker } = DatePicker
const { Option } = Select

const InternalDocumentIncomingDocAdvanceFilterV2 = props => {
  const { authorityStore, handleChangeParams, queryParamsIncoming } = props

  const { authorityIssuedsList } = authorityStore

  const [showFilter, setShowFilter] = useState(false)
  const location = useLocation()
  const queryStringParse = useMemo(
    () => qs.parse(location.search.replace('?', '')),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse.title)) count++
    if (hasValue(queryStringParse.incoming_number)) count++
    if (hasValue(queryStringParse.document_number)) count++
    if (
      queryParamsIncoming?.only_unread === 'true' ||
      queryParamsIncoming?.only_unread === true
    )
      count++
    if (
      queryStringParse.from_incoming_date ||
      queryStringParse.to_incoming_date
    )
      count++
    if (queryStringParse.from_date_issued || queryStringParse.to_date_issued)
      count++
    if (hasValue(queryStringParse.signer)) count++
    if (hasValue(queryStringParse.authority_name)) count++

    return count
  }, [queryStringParse, queryParamsIncoming])

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        title: queryStringParse.title || undefined,
        incoming_number: queryStringParse.incoming_number || undefined,
        document_number: queryStringParse.document_number || undefined,
        only_unread:
          queryParamsIncoming?.only_unread === 'true' ||
          queryParamsIncoming?.only_unread === true,
        incoming_date:
          queryStringParse.from_incoming_date &&
          queryStringParse.to_incoming_date
            ? [
                moment(queryStringParse.from_incoming_date),
                moment(queryStringParse.to_incoming_date),
              ]
            : undefined,
        date_issued:
          queryStringParse.from_date_issued && queryStringParse.to_date_issued
            ? [
                moment(queryStringParse.from_date_issued),
                moment(queryStringParse.to_date_issued),
              ]
            : undefined,
        signer: queryStringParse.signer || undefined,
        authority_name:
          queryStringParse.authority_name &&
          String(queryStringParse.authority_name).trim() !== ''
            ? [queryStringParse.authority_name]
            : [],
      })
    }
  }, [queryStringParse, queryParamsIncoming, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      title: values.title ? values.title.trim() : null,
      document_number: values.document_number
        ? values.document_number.trim()
        : null,
      incoming_number: values.incoming_number
        ? values.incoming_number.trim()
        : null,
      only_unread: values.only_unread ? true : false,
      from_incoming_date: values.incoming_date
        ? moment(values.incoming_date[0]).format(ISO_DATE_FORMAT)
        : null,
      to_incoming_date: values.incoming_date
        ? moment(values.incoming_date[1]).format(ISO_DATE_FORMAT)
        : null,
      from_date_issued: values.date_issued
        ? moment(values.date_issued[0]).format(ISO_DATE_FORMAT)
        : null,
      to_date_issued: values.date_issued
        ? moment(values.date_issued[1]).format(ISO_DATE_FORMAT)
        : null,
      signer: values.signer ? values.signer.trim() : null,
      authority_name:
        values.authority_name && values.authority_name.length > 0
          ? values.authority_name[values.authority_name.length - 1]
          : null,
    }
    handleChangeParams(params)
    onToggleFilter()
  }

  const filterSelectOption = (input, option) => {
    return (
      utils
        .nonAccentVietnamese(option.name)
        .indexOf(utils.nonAccentVietnamese(input)) >= 0
    )
  }

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Trích yếu / Số hiệu / Số đến"
                name="title"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Trích yếu / Số hiệu / Số đến"
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Số đến"
                name="incoming_number"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder={'Nhập số đến'}
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Số hiệu"
                name="document_number"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder={'Nhập số hiệu '}
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Ngày đến"
                name="incoming_date"
                style={{ marginBottom: 16 }}>
                <RangePicker
                  placeholder={['Ngày đến: Từ ngày', 'Đến ngày']}
                  format={DATE_FORMAT_LIST}
                  style={{ width: '100%' }}
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Ngày ban hành"
                name="date_issued"
                style={{ marginBottom: 16 }}>
                <RangePicker
                  placeholder={['Ngày ban hành: Từ ngày', 'Đến ngày']}
                  format={DATE_FORMAT_LIST}
                  style={{ width: '100%' }}
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Người ký"
                name="signer"
                style={{ marginBottom: 16 }}>
                <Input placeholder={'Người ký'} allowClear className="h-40" />
              </Form.Item>
              <Form.Item
                label="Cơ quan ban hành"
                name="authority_name"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  mode="tags"
                  onChange={value => {
                    form.setFieldsValue({
                      authority_name:
                        value.length > 0 ? [value[value.length - 1]] : [],
                    })
                  }}
                  filterOption={filterSelectOption}
                  allowClear
                  showSearch
                  showArrow
                  optionFilterProp={'name'}
                  notFoundContent={<EmptyContent />}
                  placeholder={'Chọn hoặc nhập cơ quan ban hành'}
                  className="h-40 custom-multiple-select">
                  {authorityIssuedsList.map(authorityIssued => (
                    <Option
                      name={authorityIssued.name}
                      value={authorityIssued.name}
                      key={authorityIssued.id}>
                      {authorityIssued.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Trạng thái văn bản"
                name="only_unread"
                valuePropName="checked"
                style={{ marginBottom: 16 }}>
                <Checkbox>Hiển thị văn bản chưa đọc</Checkbox>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleChangeParams({}, true)
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

InternalDocumentIncomingDocAdvanceFilterV2.propTypes = {}

export default inject('authorityStore')(
  observer(InternalDocumentIncomingDocAdvanceFilterV2)
)
